import { render, staticRenderFns } from "./ScheduleView.vue?vue&type=template&id=54c70484&"
import script from "./ScheduleView.vue?vue&type=script&lang=js&"
export * from "./ScheduleView.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VFlex,VLayout,VSkeletonLoader,VSnackbar,VSwitch})
